import { queryBuilder } from '@lbs/swarm-client';

export const getGameScoreByIds = (ids) => (
  queryBuilder()
    .useSource('betting')
    .selectGame(['text_info'])
    .whereGame('id')
    .in(ids)
    .getParams()
);